import { Controller, useForm } from 'react-hook-form'
import { useDispatch } from 'react-redux'
import Box from '@/components/UI/box/Box'
import Typography from '@/components/UI/typography/Typography'
import TextField from '@/components/UI/textField/TextField'
import TextArea from '@/components/UI/textArea/TextArea'
import Button from '@/components/UI/button/Button'
import { IconNames } from '@/components/UI/Types'
import styles from './ContactUs.module.scss'
import { Regexes } from '@/helpers/regexes'
import { submitB2bRequest } from '@/redux/store/actions/btob'
import { toast } from 'react-toastify'
import { useState } from 'react'

type FieldsType = {
  label: string
  name:
    | 'name'
    | 'admin_name'
    | 'phone_number'
    | 'admin_job_position'
    | 'email'
    | 'description'
  icon?: IconNames
  rules?: any
  component: any
}

const fields: FieldsType[] = [
  {
    label: 'نام و نام خانوادگی',
    name: 'name',
    icon: 'user',
    rules: { required: 'نام و نام خانوادگی الزامی است' },
    component: TextField,
  },
  {
    label: 'نام سازمان یا آژانس',
    name: 'admin_name',
    icon: 'building-4',
    rules: { required: 'نام سازمان یا آژانس الزامی است' },
    component: TextField,
  },
  {
    label: 'شماره همراه',
    name: 'phone_number',
    icon: 'call',
    rules: {
      required: 'شماره همراه الزامی است',
      pattern: {
        value: Regexes.PHONE_NUMBER,
        message: 'شماره همراه معتبر وارد کنید',
      },
    },
    component: TextField,
  },
  {
    label: 'سمت شغلی',
    name: 'admin_job_position',
    icon: 'briefcase',
    rules: { required: 'سمت شغلی الزامی است' },
    component: TextField,
  },
  {
    label: 'ایمیل',
    name: 'email',
    icon: 'search-normal',
    rules: {
      required: 'ایمیل الزامی است',
      pattern: {
        value: Regexes.EMAIL,
        message: 'ایمیل معتبر وارد کنید',
      },
    },
    component: TextField,
  },
  {
    label: 'توضیحات',
    name: 'description',
    component: TextArea,
  },
]

const ContactUs = () => {
  const dispatch = useDispatch()
  const [loading, setLoading] = useState(false)
  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm()

  const submitHandler = data => {
    setLoading(true)
    dispatch(
      submitB2bRequest(data, (status, res) => {
        if (status === 'succeed') {
          toast.success(
            'درخواست شما با موفقیت ثبت شد، همکاران ما به زودی با شما ارتباط می گیرند.',
          )
        } else {
          toast.error('خطا در ثبت درخواست، لطفا مجددا تلاش کنید.')
          console.log('error in submitting request', res)
        }
        setLoading(false)
      }),
    )
  }

  return (
    <Box className={styles['container']} id="contactUs">
      <Box className={styles['title']}>
        <Typography variant="headlineS_Bold" component="h2">
          ثبت درخواست همکاری
        </Typography>
        <Typography component="p" variant="bodyL" color={'secondary_main'}>
          درخواست همکاری خود را ثبت کنید
        </Typography>
      </Box>

      <form
        className={styles['form-wrapper']}
        onSubmit={handleSubmit(submitHandler)}
      >
        {fields.map((item, index) => (
          <Controller
            key={'FIELD_ITEM_' + index}
            control={control}
            name={item.name}
            rules={item.rules}
            render={({ field }) => {
              const Component = item.component
              return (
                <Component
                  className={styles['field']}
                  type="text"
                  value={field.value}
                  onChange={field.onChange}
                  name={item.name}
                  icon={item.icon}
                  label={item.label}
                  error={!!errors[item.name]}
                  description={errors[item.name]?.message || ''}
                  {...(item.name === 'description'
                    ? {}
                    : { onClear: () => field.onChange('') })}
                />
              )
            }}
          />
        ))}
        <Box className={styles['button-wrapper']}>
          <Button format="primary" type="submit" size="large" loading={loading}>
            ثبت و ارسال
          </Button>
        </Box>
      </form>
    </Box>
  )
}

export default ContactUs
